import { Box, SignedActor, AHText, StoreFormattedDate } from "arkh";
import React from "react";
import { useFragment } from "react-relay";
import { graphql } from "relay-runtime";
import { TodoTimelineComment_todoComment$key } from "./__generated__/TodoTimelineComment_todoComment.graphql";

export function TodoTimelineComment(props: {
  comment: TodoTimelineComment_todoComment$key;
  commentHeaderRight?: React.ReactNode;
}) {
  const comment = useFragment(
    graphql`
      fragment TodoTimelineComment_todoComment on TodoComment {
        comment
        id
        createdByActor {
          ...SignedActor_actor
        }
        createdAtDate {
          ...StoreFormattedDate
        }
      }
    `,
    props.comment
  );

  return (
    <Box
      space="small"
      color="surface"
      cornerRadius="large"
      borderColor="border-primary"
      style={{ borderWidth: 1 }}
    >
      <Box style={{ flexDirection: "row", alignItems: "center" }}>
        {comment.createdByActor ? (
          <SignedActor signedActor={comment.createdByActor} />
        ) : null}
        <AHText
          spaceLeft="small"
          color="text-washed"
          style={{ flexShrink: 0 }}
          numberOfLines={1}
          type="detail"
        >
          {comment.createdAtDate ? (
            <StoreFormattedDate date={comment.createdAtDate} />
          ) : null}
        </AHText>
        {props.commentHeaderRight}
      </Box>
      <AHText
        spaceTop="small"
        spaceHorizontal="xxsmall"
        color="text-primary"
        type="body"
      >
        {comment.comment}
      </AHText>
    </Box>
  );
}
